import { useRef } from 'react';
import { Icon } from '../components/Icon.js';
import { useReveal } from '../lib/motion.js';

const sources = [
  { icon: 'account_balance', title: 'Tabela de contribuição do INSS', source: 'gov.br/inss', url: 'https://www.gov.br/inss/pt-br/direitos-e-deveres/inscricao-e-contribuicao/tabela-de-contribuicao-mensal' },
  { icon: 'gavel', title: 'Lei 15.270/2025 — isenção e redutor do IRRF', source: 'planalto.gov.br', url: 'https://www.planalto.gov.br/ccivil_03/_ato2023-2026/2025/lei/l15270.htm' },
  { icon: 'shield', title: 'Privacidade e tratamento dos dados', source: 'docs/privacidade.md', url: 'https://github.com/brandnexx/amigodoclt/blob/main/docs/privacidade.md' },
];

export function Methodology() {
  const root = useRef<HTMLDivElement>(null);
  useReveal(root);

  return (
    <main className="page" ref={root}>
      <div className="method-grid">
        <article className="prose" data-reveal>
          <p className="eyebrow">Transparência</p>
          <h1 className="page-title">Metodologia, fontes e limites</h1>
          <p className="intro">
            Usamos regras versionadas por competência, arredondamento em centavos e memória de cálculo.
            Cada componente é arredondado uma única vez e os valores já arredondados é que são somados —
            é por isso que o total exibido fecha com as linhas, sem sobrar centavo.
          </p>
          <p>
            As faixas de INSS, IRRF, redutor, FGTS e PLR podem ser revisadas quando a legislação mudar.
            Regras de convenção coletiva, benefícios, FPAS, Simples e Fator R exigem conferência manual:
            elas variam por categoria e por empresa, e não há base pública que permita inferi-las.
          </p>
          <p>
            O bônus entra no salário bruto e nas bases de INSS, IRRF e FGTS. Descontos personalizados
            reduzem apenas o líquido. O vale-transporte é limitado a 6% do salário-base. O FGTS aparece
            em separado porque é depósito do empregador e não sai do seu líquido.
          </p>
          <p>
            O raio-X do holerite processa o PDF em memória, não guarda o arquivo nem o texto extraído e
            mascara CPF e CNPJ antes de devolver qualquer coisa. Nada do que você envia cria histórico.
          </p>
          <div className="warning-box">
            <Icon name="warning" size={22} />
            <span>
              O projeto é uma estimativa educacional. Não substitui folha de pagamento, contador,
              sindicato ou orientação jurídica — confira sempre o holerite, o TRCT e a sua convenção coletiva.
            </span>
          </div>
        </article>

        <aside className="sources" data-reveal>
          <h2>Fontes</h2>
          {sources.map((item) => (
            <a className="source-card glass" key={item.title} href={item.url} target="_blank" rel="noopener">
              <Icon name={item.icon} size={22} />
              <span>
                <strong>{item.title}</strong>
                <span>{item.source}</span>
              </span>
              <Icon name="open_in_new" size={18} />
            </a>
          ))}
        </aside>
      </div>
    </main>
  );
}
